import { buildSortedGoalTree, createGoalTreeIndex } from '@griply/utils';
import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';
import { GetGoalsOptions } from 'shared/services/backend-api';

import { useGoals } from './use-goals';

export const useSortedGoals = (options?: GetGoalsOptions) => {
  const user = useUser();
  const goals = useGoals(options);
  const sortedLifeAreas = useSortedLocalizedLifeAreas();
  const taskCounts = useTaskCounts();
  const links = useEntityLinks();

  return useMemo(
    () =>
      buildSortedGoalTree({
        goals,
        sortedLifeAreas,
        goalGroupBy: user?.settings?.goalGroupBy,
        goalSortingMode: user?.settings?.goalSortingMode,
        goalRoadmapSorting: user?.settings?.goalRoadmapSorting,
        goalGroupSorting: user?.settings?.goalGroupSorting,
        taskCounts: taskCounts?.byGoalId,
        goalProgressCounts: taskCounts?.byGoalProgress,
        index: createGoalTreeIndex(goals, { links }),
        links,
      }),
    [
      goals,
      links,
      sortedLifeAreas,
      user?.settings?.goalGroupBy,
      user?.settings?.goalGroupSorting,
      user?.settings?.goalRoadmapSorting,
      user?.settings?.goalSortingMode,
      taskCounts?.byGoalId,
      taskCounts?.byGoalProgress,
    ],
  );
};
